import type { CellContext } from "@tanstack/react-table";

import { PlusFormatter } from "./plus-formatter";
import type { IIntegrationRepositoriesAttr } from "./types";

const plusFormatterRender = (
  cell: CellContext<IIntegrationRepositoriesAttr, unknown>,
  plusFunction: (repo?: IIntegrationRepositoriesAttr) => void,
): JSX.Element => <PlusFormatter cell={cell} plusFunction={plusFunction} />;

export { plusFormatterRender };
